import _ from 'lodash'

const group = (flatParts) => {
    return _.chain(flatParts)
        .groupBy((part) => part.article + part.brand_title)
        .map((parts) => {
            const first = _.first(parts)

            const image = _.has(first, 'image') && first.image ? first.image : false

            return {
                article: first.article,
                original_article: first.original_article,
                brand_title: first.brand_title,
                title: first.title,
                image: image,
                notepad_hash: first.notepad_hash,
                is_ib_element: first.is_ib_element,
                part_id: first.id,
                is_kit: first.is_kit,
                is_subkit: first.is_subkit,
                is_rel_products: first.is_rel_products,
                parts: parts
            }
        })
        .value()
}

const groupPartsByArticleBrand = (groupedByGroupParts) => {
    return _.mapValues(groupedByGroupParts, (parts) => group(parts))
}

export default groupPartsByArticleBrand
